import {SET_BRANDS, SET_LOADING, SET_MODELS, SET_MODEL_LOADING, TOGGLE_BRAND_DETAILS} from './types'

export const mutations = {
    [SET_BRANDS](state, brands) {
        state.brands = brands.map(brand => ({
            ...brand,
            _showDetails: false,
            _loadingModels: false
        }))
    },
    [SET_LOADING](state, value) {
        state.isLoading = value
    },
    [SET_MODELS](state, {brandId, models}) {
        const brand = state.brands.find(b => b.id === brandId)
        if (brand) brand.models = models
    },
    [SET_MODEL_LOADING](state, {brandId, value}) {
        const brand = state.brands.find(b => b.id === brandId)
        if (brand) brand._loadingModels = value
    },
    [TOGGLE_BRAND_DETAILS](state, brandId) {
        const brand = state.brands.find(b => b.id === brandId)
        if (brand) {
            brand._showDetails = !brand._showDetails
        }
    },
}
